export type Nullable<T> = {
  [P in keyof T]: T[P] | null;
};

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};

export interface DictionaryDTO {
  id: number;
  title: string;
  code: string;
  default?: boolean | null;
}

export enum CustomExceptions {
  PageNotFound = 'PageNotFound',
  BadUserInfo = 'BadUserInfo',
  ValidationFailed = 'Validation is failed',
}

export enum CustomErrorsMessages {
  FailedToGetAvailableCompanies = 'Failed to get user companies',
  NoCompaniesFound = 'No companies found',
  NotRecognizedAccountDetails = 'Account details are not recognized',
  SomethingWentWrong = 'Something went wrong',
  ValidationError = 'Validations have failed',
  ExpiredLoginLink = 'Login link is expired',
  InactiveLoginLink = 'Login link is inactive',
  InvalidPhoneNumber = 'Phone number is invalid',
  InvalidOrExpiredAdminLoginSessionId = 'Admin login session is invalid or expired',
  EmailIsNotValidOrCredentialsDoNotMatch = 'Invalid email or credentials',
  InactiveUser = 'Please contact your inside sales representative to sign in.',
  ShouldFollowInvitationLink = 'An invitation was sent to you inbox. Please follow the link to create your account.',
  ShouldRequestNewInvitationLink = 'Account details are not recognized',
  InactiveAccount = 'Your account is currently inactive. Please reach out to your primary GAF Energy contact for assistance.',
}

export type PortalJwtPayload = {
  assistedByAdmin: 'False' | 'True';
  assistingAdminId: string;
  assistingAdminName?: string;
  aud: string;
  authorizedToSell: 'True';
  companyId: string;
  companyName: string;
  contractorZoneCompanyId: string;
  contractorZoneUserId?: string;
  email: string;
  exp: number;
  iss: string;
  role: 'Admin' | 'Sales';
  userId: string;
};

export enum MediaType {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}
